export const useTranslation = (key: string, default_string?: string) => {
    const nuxtApp = useNuxtApp();
    const route = useRoute();
    if (route && route.query && route.query.showTranlsationKeys === 'true') {
        return key;
    }
    
    return nuxtApp.$i18n.t(key,default_string, {
        missingWarn: false,
        silentTranslationWarn: true,
        fallbackWarn: false
    });
};
